// client/src/utils/quotationVessel.ts
/**
 * The vessel a quotation names (D104.12), on its screen, its Send form, its Client view and the PDFs and
 * Excel the client receives: its OWN copy (`customer.vesselName`) first, then the RFQ's (`rfqId.vesselName`,
 * when the RFQ is at hand). Null - never a placeholder - when neither says, so each document words its own
 * blank ("N/A" on a PDF, an empty cell on the Excel).
 *
 * Two places because the quotation copies the vessel at generation and a quotation whose copy is blank
 * while its RFQ names the ship exists. The screens already showed the RFQ's; the PDFs and the Excel read
 * only the copy and printed "N/A" to the client. The owner's rule covers every place a quotation names its
 * vessel, client-facing documents included.
 *
 * Pure. A value that is not text names nothing and never throws, the same on both sides.
 * Registered as BUSINESS_RULES#quotation-vessel-name.
 *
 * MIRRORED FILE: client/src/utils/quotationVessel.ts is a line-for-line twin. Change one, change both;
 * `mirroredUtilParity.test.js` checks. The server reads it through
 * `vesselAssignment.service.resolveQuotationVesselName`, which adds the one RFQ read.
 */

function text(value: unknown): string {
  return typeof value === 'string' ? value.trim() : '';
}

/**
 * A quotation. `rfqId` names a vessel only when the RFQ is populated: a bare id (a string, an ObjectId)
 * has no `vesselName`.
 */
export function quotationVesselName(
  q:
    | {
        customer?: { vesselName?: string | null } | null;
        rfqId?: string | { vesselName?: string | null } | null;
      }
    | null
    | undefined
): string | null {
  const own = text(q && q.customer && q.customer.vesselName);
  if (own) return own;
  const rfq = q && q.rfqId && typeof q.rfqId === 'object' ? text(q.rfqId.vesselName) : '';
  return rfq || null;
}
